import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Revamp from './Revamp';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Revamp page="home" />} />
        <Route path="/services" element={<Revamp page="services" />} />
        <Route path="/packages" element={<Revamp page="packages" />} />
        <Route path="/examples" element={<Revamp page="examples" />} />
        <Route path="/free-review" element={<Revamp page="review" />} />
        <Route path="/about" element={<Revamp page="about" />} />
        <Route path="/contact" element={<Revamp page="contact" />} />
      </Routes>
    </Router>
  );
}

export default App;
